let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("nwI1a")).then(() => parcelRequire('i6ZtS'));